import { render, staticRenderFns } from "./SelecoesInscricaoView.vue?vue&type=template&id=1793574a"
import script from "./SelecoesInscricaoView.vue?vue&type=script&lang=js"
export * from "./SelecoesInscricaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports